
import VuePicker from 'vue-pickers'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getDisplayName, getuserCurrentApp } from '@/utils/cookies.ts'
import { AppModule, DeviceType } from '@/store/modules/app'
import { UserModule } from '@/store/modules/user'
import { LIVEISSUESAPI } from '@/api/live'
import { CONFIGAPI } from '@/api/config'

@Component({
  components: {
    VuePicker
  }
})
export default class AppMain extends Vue {
  @Prop({ default: false }) private editForm!: any // 编辑表单时用到的表单数据
  private editId = 0
  private isDisableSubmit = false // 避免重复触发提交按钮
  private locationOptions = [] // 所在地区options
  // 联动下拉框手机端
  private pickerIssueVisible = false // 点击所在地区文本框，显示picker联动
  private defaultIssueIndex = [] as number[] // 默认联动定位，从0开始，0代表第一行
  private liveIssueCn = '' // 移动端：所在地区内容

  private isShowPosition = true // 是否显示房间号输入

  formData = {
    tutorName: this.username,
    issueDate: new Date(),
    is_living: 0,
    is_official: 0,
    location: [] as any,
    position: '',
    describe: ''
  }

  formRules: object = {
    tutorName: [{ required: true }],
    issueDate: [{ required: true }],
    is_living: [{ required: true, message: '请选择是否正在直播', trigger: 'change' }],
    is_official: [{ required: true, message: '请选择保障类型', trigger: 'change' }],
    location: [{ required: true, message: '请选择所在地区', trigger: 'change' }],
    position: [{ required: true, message: '请填写直播间号', trigger: 'blur' }],
    describe: [{ required: true, message: '请简单描述遇到的问题', trigger: 'blur' }]
  }

  pickerOptions: object = {
    disabledDate(time: any) {
      return time.getTime() > Date.now()
    }
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get isEdit() {
    return !!this.editForm
  }

  // 工单类型
  get ticketType() {
    if (this.isEdit) {
      return this.editForm.ticket_type
    }
    return this.$route.name === 'tutor' ? 2 : 3
  }

  // 标题
  get formTitle() {
    let title = '直播保障'
    // title += this.ticketType === 2 ? '班主任' : 'LP(学规)'
    title += this.isEdit ? '工单编辑' : '工单录入'
    return title
  }

  get device() {
    return AppModule.device
  }

  get classObj() {
    return {
      mobile: this.device === DeviceType.Mobile
    }
  }

  get username() {
    return getDisplayName()
  }

  mounted() {
    this.getTutorIssueType() // 获取班主任所在地区列表
    // 编辑时location值设置
    if (this.isEdit) {
      this.assignFormdata()
      this.handleChangeLocation(this.formData.location)
    }
  }

  private handleChangeLocation(value: any) {
    const result = this.locationOptions.filter((item: any) => {
      return item.id === value[0] && item.label.indexOf('在家') === -1
    })
    this.isShowPosition = result.length > 0
    if (this.formData.position === '无') {
      this.formData.position = ''
    }
  }

  // 判断是否是创建人，受理人列表中禁用掉创建人
  private isCreater(item: any) {
    return item.workcode === UserModule.workcode
  }

  // 获取班主任所在地区列表
  private async getTutorIssueType() {
    const { data } = await CONFIGAPI.getLocation({ app_id: this.userCurrentApp })
    let newData: any = []
    // 删掉掉没有基地的地区
    data.map((item: any) => {
      if (item.children && item.children.length !== 0) {
        newData.push(item)
      }
    })
    if (this.classObj.mobile) { // 手机端插件数据结构需要用value
      newData = JSON.parse(JSON.stringify(newData).replace(/"id"/g, '"value"'))
    }
    this.locationOptions = newData
    const locationValues: any = []
    // 移动端：编辑时定位直播间级联的默认位置
    if (this.classObj.mobile && this.isEdit) {
      this.locationOptions.some((parent: any, index1: number) => {
        if (parent.value === this.editForm.location.place_id) {
          parent.children.some((building: any, index2: number) => {
            if (building.value === this.editForm.location.building_id) {
              building.children.some((item: any, index3: number) => {
                if (item.value === this.editForm.location.floor_id) {
                  locationValues.push([parent.label, building.label, item.label])
                  this.defaultIssueIndex = [index1, index2, index3]
                }
              })
            }
          })
        }
      })
      if (JSON.stringify(locationValues).indexOf('在家') > -1) {
        this.isShowPosition = false
      } else {
        this.isShowPosition = true
      }
    }
  }

  // 移动端：所在地区联动确认
  confirmChangeIssue(res: any) {
    const issueType: string[] = []
    res.map((item: { label: string }) => {
      issueType.push(item.label)
    })
    this.liveIssueCn = issueType.join('/')
    this.formData.location = [res[0].value || res[0].id, res[1].value || res[1].id, res[2] ? res[2].value || res[2].id : '']
    if (JSON.stringify(this.liveIssueCn).indexOf('在家') > -1) {
      this.isShowPosition = false
    } else {
      this.isShowPosition = true
    }
  }

  // 编辑赋值
  assignFormdata() {
    this.editId = this.editForm.id
    const editIssueType: any = [this.editForm.location.place_id, this.editForm.location.building_id, this.editForm.location.floor_id]
    this.formData = {
      tutorName: this.editForm.creator.name,
      issueDate: this.editForm.create_time.split(' ')[0],
      is_living: this.editForm.is_living,
      is_official: this.editForm.is_official,
      location: editIssueType,
      position: this.editForm.position,
      describe: this.editForm.describe
    }
    this.liveIssueCn = this.editForm.location.place + '/' + this.editForm.location.building + '/' + this.editForm.location.floor
  }

  handleSubmit(formName: string) {
    if (!this.isShowPosition) {
      this.formData.position = '无'
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'addIssue'
        await (LIVEISSUESAPI as any)[action]({
          location: Number(this.formData.location[2].split('_')[1]),
          describe: this.formData.describe,
          position: this.formData.position,
          is_living: this.formData.is_living,
          is_official: this.formData.is_living
        }, {
          app_id: this.userCurrentApp
        }).then((res: any) => {
          if (res.stat === 1) {
            this.$message.success('提交成功')
            this.handleResetForm(formName)
            this.$router.push({ path: '/home' })
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleEditSubmit(formName: string) {
    if (!this.isShowPosition) {
      this.formData.position = '无'
    }

    const form: any = this.$refs[formName]
    form.validate(async (valid: boolean) => {
      if (valid) {
        this.isDisableSubmit = true
        const action = 'editIssue'
        await (LIVEISSUESAPI as any)[action]({
          id: this.editId,
          location: Number(this.formData.location[2].split('_')[1]),
          describe: this.formData.describe,
          position: this.formData.position,
          is_living: this.formData.is_living,
          is_official: this.formData.is_living
        }).then((res: any) => {
          if (res.stat === 1) {
            this.$emit('handleSuccess', res)
            this.$emit('handleCloseDialog')
          }
          this.isDisableSubmit = false
        }).catch(() => {
          this.isDisableSubmit = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }

  handleResetForm(formName: string) {
    this.liveIssueCn = ''
    this.defaultIssueIndex = [0, 0, 0]
    const form: any = this.$refs[formName]
    form.resetFields()
    this.formData.location = [0, 0, 0]
  }
}
